import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type SetApiConfigurationResponseType = {};

export type SetGlobalApiConfigurationParams = {
  channel_cost_ratio_sms: number;
  channel_cost_ratio_push: number;
  last_send_threshold_sms: number;
  last_send_threshold_push: number;
  last_purchase_threshold_sms: number;
  last_purchase_threshold_push: number;
  audience_exclude_all_channels: boolean;
};

export const useSetGlobalApiConfiguration = (
  options?: MutationOptions<
    SetApiConfigurationResponseType,
    SetGlobalApiConfigurationParams,
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async (params) => {
      const { data } = await api.post<
        ApiResponse<SetApiConfigurationResponseType>
      >('/configuration/global', params);

      return data.data;
    },
    ...options,
  });
